import {EditorSDK} from '@wix/editor-platform-sdk-types';
import {addApplications, isMembersAreaInstalled, MA_APP_IDS} from '@wix/members-area-integration-kit';

export async function productWithSubscriptionSaved(sdk: EditorSDK) {
  if (await isMembersAreaInstalled(sdk)) {
    return addApplications(sdk, [MA_APP_IDS.MY_SUBSCRIPTIONS]);
  }
}
